<template>
  <div class="account-pages my-5 pt-sm-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6 col-lg-4 col-xl-4">
          <div class="card overflow-hidden">
            <template v-if="state === 1">
              <div class="bg-login text-center">
                <div class="bg-login-overlay"></div>
                <div class="position-relative">
                    <h5 class="text-white font-size-20">Bem-vindo(a) de volta!</h5>
                    <p class="text-white-50 mb-0">Entre com os seus dados para acessar o sistema.</p>
                </div>
              </div>
              <div class="card-body pt-3">
                <div class="p-2">
                  <app-form-login destiny="login" />
                  <p class="mt-3 mb-0"><a href="javascript:;" @click="state=2">Clique aqui para recuperar sua senha.</a></p>
                </div>
              </div>
          </template>
          <template v-if="state === 2">
              <div class="bg-login text-center">
                <div class="bg-login-overlay"></div>
                <div class="position-relative">
                    <h5 class="text-white font-size-20">Recuperar senha</h5>
                    <p class="text-white-50 mb-0">Entre com o seu enderço de e-mail.</p>
                </div>
              </div>
              <div class="card-body pt-3">
                <div class="p-2">
                  <app-form-request />
                  <p class="mt-3 mb-0"><a href="javascript:;" @click="state=1">Clique para voltar a tela de login.</a></p>
                </div>
              </div>
          </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppFormLogin from "@/components/AppFormLogin/AppFormLogin.vue";
import AppFormRequest from "@/components/AppFormLogin/AppFormRequestPasswordEmail.vue";
export default {
  components: {
    AppFormLogin,
    AppFormRequest
  },
  data(){
    return {
      state:1,
      emailAddress: null,
    }
  }
}
</script>
